module.exports = __webpack_public_path__ + "static/img/mac1.7ff6fae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platformIntroduce/mac1.png
// module id = PMMV
// module chunks = 70